export const EHR_NETWORK_PROVIDERS = ['commonwell', 'carequality', 'tefca'];

/** Display name for 1st party external data source (e.g. data from another org via Zus Network). */
export const FIRST_PARTY_EXTERNAL_SOURCE_DISPLAY = 'Zus Network';

export const DATA_PROVIDER_DISPLAY_NAMES: Record<string, string> = {
  commonwell: 'CommonWell',
  carequality: 'Carequality',
  tefca: 'TEFCA',
  surescripts: 'Surescripts',
  quest: 'Quest',
};
